import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import uuid from "uuid";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import ViewPortSize from "../../constants/viewPortSize";
import {
  Container as SideBarItemContainer,
  Item,
  ItemImage,
  ItemText,
  defaultProps,
  propTypes
} from "./SideBarItem";

const Container = styled(SideBarItemContainer)`
  display: flex;
  flex-direction: column;
  background-color: ${props =>
    props.active
      ? props.theme.sideBar.tab.backgroundActive
      : props.theme.sideBar.tab.background};
  line-height: 0.75rem;
  &:hover {
    background-color: ${props => {
      const bColor = props.active
        ? props.theme.sideBar.tab.backgroundActive
        : props.theme.sideBar.tab.backgroundHover;
      return props.disabled ? "#ACACAC" : bColor;
    }};
  }
`;

class SideBarTab extends Component {
  constructor() {
    super();

    this.id = uuid.v4();
  }

  render() {
    const { height, image, text, active, disabled, viewPortSize } = this.props;
    const minimized = false; // viewPortSize < ViewPortSize.LARGE;
    let onClick = this.props.onClick;
    if (disabled) {
      onClick = () => {};
    }
    return (
      <Container
        height={height}
        active={active}
        onClick={onClick}
        disabled={disabled}
        data-tip
        data-for={this.id}
      >
        <Item>
          <ItemImage src={image} />
          {!minimized ? <ItemText>{text}</ItemText> : ""}
        </Item>
        {minimized ? (
          <ReactTooltip id={this.id} type="dark" effect="solid">
            <span>{text}</span>
          </ReactTooltip>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

SideBarTab.defaultProps = defaultProps;

SideBarTab.propTypes = {
  ...propTypes,
  viewPortSize: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  viewPortSize: state.app.viewPortSize
});

export default connect(mapStateToProps)(SideBarTab);



// WEBPACK FOOTER //
// ./app/components/SideBar/SideBarTab.js